var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15491 0.32287C8.39889 0.538116 8.516 0.798207 8.50624 1.10314C8.49648 1.40807 8.3692 1.66816 8.12441 1.88341L4.67819 4.92377L18.2801 4.92377C18.6257 4.92377 18.9157 5.02709 19.1499 5.23372C19.3841 5.44036 19.5008 5.69579 19.5 6C19.5 6.30493 19.3829 6.56072 19.1487 6.76735C18.9144 6.97399 18.6249 7.07695 18.2801 7.07623L4.67818 7.07623L8.15491 10.1435C8.39889 10.3587 8.52088 10.6145 8.52088 10.9109C8.52088 11.2072 8.39889 11.4626 8.15491 11.6771C7.91092 11.8924 7.62099 12 7.28512 12C6.94924 12 6.65971 11.8924 6.41654 11.6771L0.835494 6.75336C0.713503 6.64574 0.626889 6.52915 0.575654 6.40359C0.524418 6.27803 0.499207 6.1435 0.50002 6C0.50002 5.8565 0.525639 5.72197 0.576874 5.59641C0.62811 5.47085 0.714316 5.35426 0.835494 5.24664L6.44704 0.295964C6.67069 0.0986546 6.95005 -1.09715e-06 7.28512 -1.06786e-06C7.62018 -1.03857e-06 7.91011 0.107624 8.15491 0.32287Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.997cbad6.svg";
export { ForwardRef as ReactComponent };